// src/components/PackingListEditor.js

import React, { useState, useEffect, useMemo } from 'react';
import {
  Card, Form, Button, Table, Input, InputNumber, Space, Select, Tooltip,
  Typography, Divider, Row, Col, Popconfirm, message, Tabs, Spin, Tag,
  Progress, Affix, Modal, List, Image, Alert
} from 'antd';
import {
  PlusOutlined, DeleteOutlined, SaveOutlined, CheckOutlined, CloseOutlined,
  PrinterOutlined, ArrowLeftOutlined, PercentageOutlined, CameraOutlined, EyeOutlined,
  CloudUploadOutlined, DownOutlined, RightOutlined, TagsOutlined, EditOutlined // <-- IMPORTANTE: Añadir EditOutlined
} from '@ant-design/icons';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import PhotoCaptureQR from './PhotoCaptureQR';
import { catalogService, deliveryService, settingsService } from '../services/api';//nuevp v3
import { useAuth } from '../context/AuthContext';


const { Title, Text } = Typography;
const { Option } = Select;

// Componentes de animación (sin cambios)
const SuccessAnimation = ({ folio, onClose }) => { useEffect(() => { const timer = setTimeout(() => { if (onClose) onClose(); }, 3000); return () => clearTimeout(timer); }, [onClose]); return (<div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}> <div style={{ backgroundColor: 'white', borderRadius: '50%', width: '320px', height: '320px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', padding: 0, overflow: 'hidden' }}> <div style={{ backgroundColor: '#52c41a', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 0 20px 0', flexShrink: 0 }}> <CheckOutlined style={{ fontSize: '50px', color: 'white' }} /> </div> <Typography.Title level={3} style={{ margin: '5px 0', textAlign: 'center' }}>¡Guardado Exitoso!</Typography.Title> <div style={{ textAlign: 'center' }}> <Typography.Text style={{ fontSize: '14px', display: 'block' }}>Listado de Empaque</Typography.Text> <Typography.Text strong style={{ fontSize: '16px', color: '#52c41a', display: 'block' }}>{folio}</Typography.Text> <Typography.Text style={{ fontSize: '14px', display: 'block', marginTop: '5px' }}>guardado correctamente</Typography.Text> </div> </div> </div>); };
const ErrorAnimation = ({ percent, onClose }) => { useEffect(() => { const timer = setTimeout(() => { if (onClose) onClose(); }, 3500); return () => clearTimeout(timer); }, [onClose]); return (<div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}> <div style={{ backgroundColor: 'white', borderRadius: '50%', width: '320px', height: '320px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', padding: 0, overflow: 'hidden' }}> <div style={{ backgroundColor: '#ff4d4f', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 0 20px 0', flexShrink: 0 }}> <CloseOutlined style={{ fontSize: '50px', color: 'white' }} /> </div> <Typography.Title level={3} style={{ margin: '5px 0', textAlign: 'center', color: '#ff4d4f' }}> ¡Empaque Incompleto! </Typography.Title> <div style={{ textAlign: 'center', padding: '0 20px' }}> <Typography.Text style={{ fontSize: '14px', display: 'block' }}> El listado de empaque solo está al </Typography.Text> <Typography.Text strong style={{ fontSize: '16px', color: '#ff4d4f', display: 'block' }}> {percent}% </Typography.Text> <Typography.Text style={{ fontSize: '14px', display: 'block', marginTop: '5px' }}> Por favor, complete las cantidades para poder guardar. </Typography.Text> </div> </div> </div>); };

const PackingListEditor = ({ docEntry: docEntryFromProp, onBack: onBackFromProp }) => {
  const { user } = useAuth();
  const { docEntry: docEntryFromUrl } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const docEntry = docEntryFromUrl || docEntryFromProp;

  const packingListId = location.state?.packingListId;
  const isReadOnly = location.state?.readOnly || false;

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);
  const [labelsLoading, setLabelsLoading] = useState(false);
  const [deliveryData, setDeliveryData] = useState(null);
  const [pallets, setPallets] = useState([]);
  const [form] = Form.useForm();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [savedFolio, setSavedFolio] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [incompletePercent, setIncompletePercent] = useState(0);
  const [photoQrVisible, setPhotoQrVisible] = useState(false);
  const [evidenceImages, setEvidenceImages] = useState([]);
  const [uploadProgressVisible, setUploadProgressVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [totalImagesToUpload, setTotalImagesToUpload] = useState(0);
  const [currentImageProgress, setCurrentImageProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('');
  const [showServicesLabel, setShowServicesLabel] = useState(false);
  const [saveErrorAlert, setSaveErrorAlert] = useState(null);
  const [pdfErrorAlert, setPdfErrorAlert] = useState(null);
  const [catalogPalletDefinitions, setCatalogPalletDefinitions] = useState([]);
  const [loadingCatalogDefinitions, setLoadingCatalogDefinitions] = useState(true);
  const [errorCatalogDefinitions, setErrorCatalogDefinitions] = useState(null);

  // +++ INICIO: NUEVOS ESTADOS PARA EL MODAL DE DIMENSIONES MANUALES +++
  const [isManualDimModalVisible, setIsManualDimModalVisible] = useState(false);
  const [editingPalletIndex, setEditingPalletIndex] = useState(null);
  const [manualDimForm] = Form.useForm(); // Formulario para el modal
  // +++ FIN: NUEVOS ESTADOS +++

  const [minPhotosRequired, setMinPhotosRequired] = useState(6);//nuevo v3

  const permissions = useMemo(() => {
    const isOpen = deliveryData?.DocumentStatus === 'bost_Open';
    const statusKey = isOpen ? 'onOpen' : 'onClosed';
    const statusPerms = user?.role?.profile?.permissions?.actions?.packingListEditor?.[statusKey];

    if (!statusPerms) {
      return {
        canSaveOrEdit: false, canModifyContent: false, canManageEvidenceOnCreate: false,
        canManageEvidenceOnEdit: false, canViewEvidence: false, canDeleteEvidence: false, canGeneratePdf: false,
      };
    }

    const isEditMode = !!(deliveryData?.packingList?.packingListNumber);
    const canSaveOrEdit = isEditMode ? statusPerms.canEdit : statusPerms.canCreate;

    return {
      canSaveOrEdit: canSaveOrEdit, canModifyContent: canSaveOrEdit,
      canManageEvidenceOnCreate: statusPerms.canManageEvidenceOnCreate,
      canManageEvidenceOnEdit: statusPerms.canManageEvidenceOnEdit,
      canViewEvidence: statusPerms.canViewEvidence, canDeleteEvidence: statusPerms.canDeleteEvidence,
      canGeneratePdf: statusPerms.canGeneratePdf,
    };
  }, [deliveryData, user]);

  const canEditContent = !isReadOnly && permissions.canModifyContent;
  const canManageEvidence = !isReadOnly && (!!(deliveryData?.packingList?.packingListNumber) ? permissions.canManageEvidenceOnEdit : permissions.canManageEvidenceOnCreate);

  // +++ AGREGAR ESTE EFECTO  nuevo v3+++
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await settingsService.getSetting('minPhotosPerList');
        if (res.data.success && typeof res.data.data.value === 'number') {
          setMinPhotosRequired(res.data.data.value);
        }
      } catch (e) {
        console.warn("No se pudo cargar config de fotos mínimas, usando default 6");
      }
    };
    loadConfig();
  }, []);
  // +++ FIN EFECTO version 3+++


  useEffect(() => {
    if (docEntry) { fetchDeliveryDetails(true); }
    else { setLoading(false); message.warning("No se pudo determinar el DocEntry para cargar los datos."); }
  }, [docEntry, packingListId]);

  useEffect(() => {
    const fetchCatalogPalletDefinitions = async () => {
      try {
        setLoadingCatalogDefinitions(true);
        setErrorCatalogDefinitions(null);
        const response = await catalogService.getPalletDefinitions();
        if (response.data.success) { setCatalogPalletDefinitions(response.data.data || []); }
        else { throw new Error(response.data.message || 'Error al cargar catálogo.'); }
      } catch (error) {
        console.error("Error fetching catalog pallet definitions:", error);
        const errorMessage = error.message || 'No se pudo cargar el catálogo.';
        setErrorCatalogDefinitions(errorMessage);
        message.error(errorMessage);
      } finally {
        setLoadingCatalogDefinitions(false);
      }
    };
    fetchCatalogPalletDefinitions();
  }, []);

  const createNewPalletObject = (type = 'TARIMA', number = 1) => ({
    palletNumber: `${type} ${number}`, dimensions: '', weight: 0,
    items: [], isExpanded: true, type: type,
  });

  const renumberPallets = (currentPallets) => {
    let palletCounter = 0;
    let boxCounter = 0;
    return currentPallets.map(p => {
      const currentType = p.type || 'TARIMA';
      if (currentType === 'TARIMA') {
        palletCounter++;
        return { ...p, palletNumber: `TARIMA ${palletCounter}` };
      } else {
        boxCounter++;
        return { ...p, palletNumber: `CAJA ${boxCounter}` };
      }
    });
  };

  const fetchDeliveryDetails = async (isInitialLoad = false) => {
    setLoading(true);
    setShowServicesLabel(false);
    if (isInitialLoad) { setSaveErrorAlert(null); }
    if (isInitialLoad) { setDeliveryData(null); setPallets([]); setEvidenceImages([]); }
    try {
      let response;
      if (packingListId) {
        console.log(`Editor Estándar: Cargando listado específico por ID: ${packingListId}`);
        response = await deliveryService.getPackingListById(packingListId);
      } else {
        console.log(`Editor Estándar: Cargando por DocEntry: ${docEntry}`);
        const formatoQuery = isInitialLoad ? '' : '?formato=A';
        response = await deliveryService.getDeliveryDetails(docEntry, formatoQuery);
      }

      if (response.data.success) {
        const data = response.data.data;
        console.log("Editor Estándar: Datos recibidos del backend:", data);
        setDeliveryData(data);

        let serviceItemsToAdd = [];
        let initialPallets = [];

        if (isInitialLoad) {
          let newPackingListMode = (!data.packingList || !data.packingList.packingListNumber || data.packingList.formato !== 'B');
          if (newPackingListMode && data.DocumentLines) {
            serviceItemsToAdd = data.DocumentLines.filter(line => line.ItemCode && line.ItemCode.toUpperCase().startsWith("SERV"))
              .map(line => ({ clientSideId: uuidv4(), lineNum: line.LineNum, itemCode: line.ItemCode, quantity: line.Quantity, description: line.ItemDescription || line.ItemName || '', weight: line.Weight || line.SalesUnitWeight || 0, dimensions: [line.Width || line.SalesUnitWidth, line.Length || line.SalesUnitLength, line.Height || line.SalesUnitHeight].filter(Boolean).join('X') || '', }));
          }
          if (data.packingList && data.packingList.formato !== 'B' && data.packingList.pallets?.length > 0) {
            initialPallets = data.packingList.pallets.map(p => ({ ...p, isExpanded: p.isExpanded === undefined ? true : p.isExpanded, items: (p.items || []).map(item => ({ ...item, clientSideId: item.clientSideId || uuidv4() })), type: p.type || 'TARIMA' }));
            if (initialPallets[0]?.items?.some(item => item.itemCode && item.itemCode.toUpperCase().startsWith("SERV"))) { setShowServicesLabel(true); }
          } else if (data.DocumentLines?.length > 0) {
            const firstPallet = createNewPalletObject('TARIMA', 1);
            if (serviceItemsToAdd.length > 0) { firstPallet.items = [...serviceItemsToAdd]; setShowServicesLabel(true); }
            initialPallets = [firstPallet];
          } else {
            initialPallets = [];
          }
          setPallets(renumberPallets(initialPallets));
        }
        if (data.packingList && (data.packingList.formato === 'A' || !data.packingList.formato)) { setEvidenceImages(data.packingList.evidenceImages || []); }
        else if (isInitialLoad) { setEvidenceImages([]); }
        if (!isInitialLoad && data.packingList?.evidenceImages) { setEvidenceImages(data.packingList.evidenceImages); }
      } else {
        message.error(response.data.message || 'Error loading details');
      }
    } catch (error) {
      console.error('Editor Estándar: Error loading data:', error);
      message.error(error.response?.data?.message || 'Error fetching details');
      if (isInitialLoad) { setDeliveryData(null); setPallets([]); setEvidenceImages([]); }
    } finally {
      setLoading(false);
    }
  };

  const togglePalletExpansion = (palletIndex) => { setPallets(prevPallets => prevPallets.map((pallet, index) => index === palletIndex ? { ...pallet, isExpanded: !pallet.isExpanded } : pallet)); };

  const addNewPallet = () => {
    setSaveErrorAlert(null);
    setPallets(prevPallets => {
      const newPallet = createNewPalletObject('TARIMA', 1);
      const updatedPallets = [...prevPallets, newPallet];
      return renumberPallets(updatedPallets);
    });
  };

  const removePallet = (palletIndex) => {
    setSaveErrorAlert(null);
    setPallets(p => {
      const updatedPallets = p.filter((_, i) => i !== palletIndex);
      if (palletIndex === 0) {
        if (updatedPallets.length > 0 && updatedPallets[0]?.items?.some(item => item.itemCode && item.itemCode.toUpperCase().startsWith("SERV"))) { setShowServicesLabel(true); }
        else { setShowServicesLabel(false); }
      }
      return renumberPallets(updatedPallets);
    });
  };

  const updatePalletDetails = (palletIndex, field, value) => {
    setSaveErrorAlert(null);
    setPallets(p => {
      let palletsToUpdate = p.map((pallet, i) => {
        if (i === palletIndex) {
          if (field === 'dimensions') {
            const definition = catalogPalletDefinitions.find(def => def.dimensions === value);
            return { ...pallet, dimensions: value, type: definition ? definition.type : pallet.type };
          }
          return { ...pallet, [field]: value };
        }
        return pallet;
      });
      return renumberPallets(palletsToUpdate);
    });
  };

  const addItemToPallet = (palletIndex) => {
    setSaveErrorAlert(null);
    const newItem = { clientSideId: uuidv4(), lineNum: null, itemCode: '', quantity: 1, description: '', weight: 0, dimensions: '' };
    setPallets(p => p.map((pallet, i) => i === palletIndex ? { ...pallet, items: [...pallet.items, newItem] } : pallet));
  };

  const removeItemFromPallet = (palletIndex, itemIndex) => {
    setSaveErrorAlert(null);
    setPallets(p => {
      const newPallets = p.map((pallet, i) => {
        if (i === palletIndex) { return { ...pallet, items: pallet.items.filter((_, j) => j !== itemIndex) }; }
        return pallet;
      });
      if (palletIndex === 0) {
        if (newPallets[0]?.items?.some(item => item.itemCode && item.itemCode.toUpperCase().startsWith("SERV"))) { setShowServicesLabel(true); }
        else { setShowServicesLabel(false); }
      }
      return newPallets;
    });
  };

  const updateItem = (palletIndex, itemIndex, field, value) => {
    setSaveErrorAlert(null);
    const currentItem = pallets[palletIndex].items[itemIndex];
    if (field === 'quantity') {
      const currentItemCode = currentItem.itemCode;
      const currentItemLineNum = currentItem.lineNum;
      if (!currentItemCode || currentItemLineNum === null || !deliveryData?.DocumentLines) {
        if (currentItemLineNum === null && currentItemCode) { message.warn(`Seleccione una línea de pedido específica para '${currentItemCode}' para validar la cantidad.`, 3); }
      } else {
        const originalDocumentLine = deliveryData.DocumentLines.find(line => line.ItemCode === currentItemCode && line.LineNum === currentItemLineNum);
        if (!originalDocumentLine) { message.error(`Error: No se encontró la línea de pedido original (${currentItemLineNum}) para ${currentItemCode}.`); return; }
        const originalQuantity = originalDocumentLine.Quantity || 0;
        if (originalQuantity <= 0) { message.warning(`El artículo ${currentItemCode} (Línea ${currentItemLineNum}) no tiene cantidad original.`); }
        let currentTotalPackedForLine = 0;
        pallets.forEach((p, pIdx) => {
          p.items.forEach((item, iIdx) => {
            if (item.itemCode === currentItemCode && item.lineNum === currentItemLineNum && !(pIdx === palletIndex && iIdx === itemIndex)) {
              currentTotalPackedForLine += (item.quantity || 0);
            }
          });
        });
        const newQuantity = Number(value) || 0;
        const potentialTotalPacked = currentTotalPackedForLine + newQuantity;
        if (potentialTotalPacked > originalQuantity) {
          message.error(`Cantidad para ${currentItemCode} (Línea ${currentItemLineNum}) excede límite (${originalQuantity}). Máx. a añadir: ${Math.max(0, originalQuantity - currentTotalPackedForLine)}`);
          return;
        }
      }
    }
    setPallets(prevPallets => prevPallets.map((pallet, pIdx) => {
      if (pIdx === palletIndex) {
        const updatedItems = pallet.items.map((item, itmIdx) => {
          if (itmIdx === itemIndex) {
            let updatedItem = { ...item };
            if (field === 'selectedLineNum' && deliveryData?.DocumentLines) {
              const selectedSapLineNum = value;
              const selectedOriginalLine = deliveryData.DocumentLines.find(line => line.LineNum === selectedSapLineNum);
              if (selectedOriginalLine) {
                updatedItem.itemCode = selectedOriginalLine.ItemCode;
                updatedItem.description = selectedOriginalLine.ItemName || selectedOriginalLine.ItemDescription || '';
                updatedItem.lineNum = selectedOriginalLine.LineNum;
                updatedItem.weight = selectedOriginalLine.Weight || selectedOriginalLine.SalesUnitWeight || 0;
                const dims = [];
                if (selectedOriginalLine.Width || selectedOriginalLine.SalesUnitWidth) dims.push(`${selectedOriginalLine.Width || selectedOriginalLine.SalesUnitWidth}`);
                if (selectedOriginalLine.Length || selectedOriginalLine.SalesUnitLength) dims.push(`${selectedOriginalLine.Length || selectedOriginalLine.SalesUnitLength}`);
                if (selectedOriginalLine.Height || selectedOriginalLine.SalesUnitHeight) dims.push(`${selectedOriginalLine.Height || selectedOriginalLine.SalesUnitHeight}`);
                updatedItem.dimensions = dims.length > 0 ? dims.join('X') : '';
              } else {
                updatedItem.itemCode = ''; updatedItem.description = ''; updatedItem.lineNum = null; updatedItem.weight = 0; updatedItem.dimensions = '';
              }
            } else {
              updatedItem = { ...item, [field]: value };
            }
            return updatedItem;
          }
          return item;
        });
        return { ...pallet, items: updatedItems };
      }
      return pallet;
    }));
  };

  const overallProgress = useMemo(() => {
    if (!deliveryData?.DocumentLines || deliveryData.DocumentLines.length === 0) { return 0; }
    let totalOrderQuantity = 0;
    let totalEffectivelyPackedQuantity = 0;
    deliveryData.DocumentLines.forEach(docLine => {
      if (docLine.Quantity && docLine.Quantity > 0) {
        totalOrderQuantity += docLine.Quantity;
        let packedForThisDocLine = 0;
        pallets.forEach(pallet => {
          pallet.items.forEach(item => {
            if (item.itemCode === docLine.ItemCode && item.lineNum === docLine.LineNum) {
              packedForThisDocLine += (parseInt(item.quantity, 10) || 0);
            }
          });
        });
        totalEffectivelyPackedQuantity += Math.min(packedForThisDocLine, docLine.Quantity);
      }
    });
    if (totalOrderQuantity === 0) { return 100; }
    return Math.min(100, Math.floor((totalEffectivelyPackedQuantity / totalOrderQuantity) * 100));
  }, [deliveryData, pallets]);

  const serialsDataSource = useMemo(() => {
    if (!deliveryData?.DocumentLines) { return []; }
    const serialsList = [];
    deliveryData.DocumentLines.forEach((line) => {
      if (line.SerialNumbers && Array.isArray(line.SerialNumbers)) {
        line.SerialNumbers.forEach((serialItem, serialIndex) => {
          const serialNumber = serialItem.InternalSerialNumber || serialItem.ManufacturerSerialNumber || serialItem.SerialNumber || serialItem.DistNumber || serialItem.BatchID || (typeof serialItem === 'string' ? serialItem : null);
          if (serialNumber) { serialsList.push({ key: `${line.LineNum}-${serialIndex}-${serialNumber}`, itemCode: line.ItemCode, description: line.ItemDescription || '', serialNumber: serialNumber, lineNum: line.LineNum }); }
        });
      }
    });
    return serialsList;
  }, [deliveryData]);

  const savePackingList = async () => {
    setSaveErrorAlert(null);

    if (!deliveryData) {
      message.error("No hay datos de entrega cargados.");
      return;
    }

    for (const pallet of pallets) {
      if (pallet.items.length === 0) {
        setSaveErrorAlert(`No se puede guardar: La ${pallet.palletNumber} está vacía. Por favor, agregue artículos o elimine la tarima.`);
        return;
      }
    }

    for (const pallet of pallets) {
      for (const item of pallet.items) {
        if (!item.itemCode) {
          setSaveErrorAlert(`No se puede guardar: La ${pallet.palletNumber} contiene artículos sin un código asignado. Por favor, seleccione un código para todos los artículos o elimine las filas vacías.`);
          return;
        }
      }
    }

    let isComplete = true;
    if (!deliveryData?.DocumentLines || deliveryData.DocumentLines.length === 0) {
      isComplete = true;
    } else {
      for (const docLine of deliveryData.DocumentLines) {
        const requiredQty = docLine.Quantity || 0;
        if (requiredQty <= 0 || (docLine.ItemCode && docLine.ItemCode.toUpperCase().startsWith("SERV"))) {
          continue;
        }
        let packedQty = 0;
        pallets.forEach(pallet => {
          pallet.items.forEach(item => {
            if (item.itemCode === docLine.ItemCode && item.lineNum === docLine.LineNum) {
              packedQty += (parseInt(item.quantity, 10) || 0);
            }
          });
        });
        if (packedQty < requiredQty) {
          isComplete = false;
          break;
        }
      }
    }

    if (!isComplete) {
      setIncompletePercent(overallProgress);
      setSaveErrorAlert('Favor de completar todos los datos del empaque: El listado de artículos no está completado al 100%.');
      setShowErrorModal(true);
      return;
    }
/***nuevo v3 */
    if (!evidenceImages || evidenceImages.length < minPhotosRequired) { // <--- USAR VARIABLE
      setSaveErrorAlert(`Favor de completar todos los datos del empaque: Debe agregar al menos ${minPhotosRequired} fotos de evidencia.`);
      return;
    }

    let palletDataComplete = true;
    for (const pallet of pallets) {
      if (!pallet.dimensions) {
        palletDataComplete = false;
        break;
      }
      if (!(typeof pallet.weight === 'number' && pallet.weight > 0)) {
        palletDataComplete = false;
        break;
      }
    }

    if (!palletDataComplete) {
      setSaveErrorAlert("Favor de completar todos los datos del empaque: Verifique dimensiones y peso de todas las tarimas.");
      return;
    }

    try {
      setSaving(true);
      const newImagesToUpload = evidenceImages.filter(img => img.imageData && !img.sapAttachmentAbsoluteEntry);
      setTotalImagesToUpload(newImagesToUpload.length);
      if (newImagesToUpload.length > 0) {
        setUploadProgressVisible(true); setCurrentImageIndex(0); setCurrentImageProgress(0); setUploadStatus('Preparando carga de imágenes...');
      }

      const formValues = await form.validateFields();
      const currentComments = formValues.comments || '';

      const payload = {
        formato: 'A', status: 'completed', docNum: deliveryData.DocNum,
        cardCode: deliveryData.CardCode, cardName: deliveryData.CardName,
        packDate: moment().format('YYYY-MM-DD'), packUser: user?.fullName || 'Usuario del Sistema',
        comments: currentComments,
        pallets: pallets.map(p => ({ palletNumber: p.palletNumber, dimensions: p.dimensions, weight: p.weight, items: p.items.map(({ clientSideId, ...item }) => item), type: p.type || 'TARIMA' })),
        evidenceImages: evidenceImages,
      };
      console.log("Editor Estándar: Saving payload:", payload);

      const response = await deliveryService.savePackingList(docEntry, payload);

      if (response.data.success) {
        const backendPackingList = response.data.data;
        setSavedFolio(backendPackingList.packingListNumber);
        setDeliveryData(prev => ({ ...prev, packingList: backendPackingList }));
        setPallets((backendPackingList.pallets || []).map(p => ({ ...p, isExpanded: p.isExpanded === undefined ? true : p.isExpanded, items: (p.items || []).map(item => ({ ...item, clientSideId: item.clientSideId || uuidv4() })) })));
        setEvidenceImages(backendPackingList.evidenceImages || []);
        setPallets(prev => renumberPallets(prev));
        setShowSuccessModal(true);
        if (backendPackingList.pallets && backendPackingList.pallets.length > 0 && backendPackingList.pallets[0].items?.some(item => item.itemCode && item.itemCode.toUpperCase().startsWith("SERV"))) {
          setShowServicesLabel(true);
        } else {
          setShowServicesLabel(false);
        }
      } else {
        setSaveErrorAlert(response.data.message || 'Error al guardar el Listado de Empaque.');
      }
    } catch (error) {
      if (error.errorFields) {
        console.error('Error de validación del formulario:', error.errorFields);
        setSaveErrorAlert('Por favor, corrija los errores en el formulario.');
      } else {
        console.error('Editor Estándar: Save error:', error);
        setSaveErrorAlert(error.response?.data?.message || 'Error de red/servidor al guardar.');
      }
    } finally {
      setSaving(false); setUploadProgressVisible(false);
    }
  };

  const generatePDF = async () => {
    setSaveErrorAlert(null);
    setPdfErrorAlert(null);
    const packingListId = deliveryData?.packingList?._id;
    if (!packingListId) { message.warning('Debe guardar el listado de empaque primero para generar el PDF.'); return; }
    message.info("Generando PDF...");
    setPrintLoading(true);
    try {
      await deliveryService.generatePDF(packingListId);
    } catch (error) {
      console.error("Error al generar PDF:", error);
      message.error(error.response?.data?.message || "Error al generar PDF.");
      setPdfErrorAlert("No se pudo generar el PDF. Por favor, intente de nuevo más tarde.");
    } finally {
      setPrintLoading(false);
    }
  };

  const handleGenerateLabels = async () => {
    setPdfErrorAlert(null);
    const packingListId = deliveryData?.packingList?._id;
    if (!packingListId) { message.warning('Debe guardar el listado de empaque primero para generar las etiquetas.'); return; }
    message.info("Generando Etiquetas...");
    setLabelsLoading(true);
    try {
      await deliveryService.generateLabels(packingListId);
    } catch (error) {
      console.error("Error al generar etiquetas:", error);
      message.error(error.response?.data?.message || "Error al generar las etiquetas.");
      setPdfErrorAlert("No se pudieron generar las etiquetas. Por favor, intente de nuevo más tarde.");
    } finally {
      setLabelsLoading(false);
    }
  };

  const handlePhotoCaptureComplete = () => { setSaveErrorAlert(null); setPhotoQrVisible(false); fetchDeliveryDetails(false); };
  const totalUploadProgress = useMemo(() => { if (totalImagesToUpload === 0) return 0; const completedImages = currentImageIndex; const currentProgress = currentImageProgress / 100; return Math.round(((completedImages + currentProgress) / totalImagesToUpload) * 100); }, [currentImageIndex, currentImageProgress, totalImagesToUpload]);
  useEffect(() => { let intervalId = null; if (uploadProgressVisible && currentImageIndex < totalImagesToUpload) { setUploadStatus(`Subiendo imagen ${currentImageIndex + 1} de ${totalImagesToUpload} a SAP...`); intervalId = setInterval(() => { setCurrentImageProgress(prev => { const newProgress = prev + 5; if (newProgress >= 100) { clearInterval(intervalId); setTimeout(() => { if (currentImageIndex < totalImagesToUpload - 1) { setCurrentImageIndex(prevIdx => prevIdx + 1); setCurrentImageProgress(0); } else { setUploadStatus('¡Imágenes subidas exitosamente!'); } }, 500); return 100; } return newProgress; }); }, 200); } return () => { if (intervalId) clearInterval(intervalId); }; }, [uploadProgressVisible, currentImageIndex, totalImagesToUpload]);

  const handleBack = () => {
    if (onBackFromProp) { onBackFromProp(); return; }
    const returnPath = location.state?.from || '/deliveries';
    let navigationState = {};
    if (location.state?.activeTabKey) { navigationState = { activeTab: location.state.activeTabKey }; }
    console.log(`Navegando de vuelta a: ${returnPath}`);
    console.log('Enviando el siguiente estado:', navigationState);
    navigate(returnPath, { state: navigationState });
  };

  // +++ INICIO: NUEVAS FUNCIONES PARA MANEJO DE DIMENSIONES MANUALES +++
  const handleDimensionChange = (value, palletIndex) => {
    if (value === 'manual') {
      setEditingPalletIndex(palletIndex);
      setIsManualDimModalVisible(true);
      manualDimForm.resetFields();
    } else {
      updatePalletDetails(palletIndex, 'dimensions', value);
    }
  };

  const handleEditManualDimensions = (palletIndex) => {
    const pallet = pallets[palletIndex];
    if (!pallet || !pallet.dimensions) return;

    const regex = /(?:(Caja)\s)?\(?(\d+)x(\d+)x(\d+)\)?/;
    const match = pallet.dimensions.match(regex);

    if (match) {
      const [, typeStr, length, width, height] = match;
      const type = typeStr ? 'CAJA' : 'TARIMA';

      manualDimForm.setFieldsValue({
        length: Number(length),
        width: Number(width),
        height: Number(height),
        type: type,
      });

      setEditingPalletIndex(palletIndex);
      setIsManualDimModalVisible(true);
    } else {
      message.warn("No se pudieron leer las dimensiones actuales, por favor ingréselas de nuevo.");
      setEditingPalletIndex(palletIndex);
      setIsManualDimModalVisible(true);
      manualDimForm.resetFields();
    }
  };

  const handleManualSave = (values) => {
    const { length, width, height, type } = values;

    let newDimensionsString = `${length}x${width}x${height}`;
    if (type === 'CAJA') {
      newDimensionsString = `Caja (${newDimensionsString})`;
    }

    updatePalletDetails(editingPalletIndex, 'dimensions', newDimensionsString);
    updatePalletDetails(editingPalletIndex, 'type', type);

    setIsManualDimModalVisible(false);
    setEditingPalletIndex(null);
    message.success(`Dimensiones manuales '${newDimensionsString}' asignadas.`);
  };
  // +++ FIN: NUEVAS FUNCIONES +++

  if (loading && !deliveryData) { return (<div style={{ textAlign: 'center', padding: '50px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}><Spin size="large" /><Text style={{ marginTop: 8 }}>Cargando Editor...</Text></div>); }
  if (!deliveryData && !loading) { return <Card><Typography.Text type="danger">No se pudieron cargar datos para el Editor.</Typography.Text><Button onClick={handleBack} style={{ marginTop: 16 }}>Volver</Button></Card>; }

  const isEditMode = !!(deliveryData?.packingList?.packingListNumber);
  const isEvidenceTabVisible = !isEditMode || permissions.canViewEvidence || permissions.canManageEvidenceOnEdit;

  const tabItems = [
    {
      key: 'pallets',
      label: 'Tarimas',
      children: (
        <>
          {pallets.map((pallet, palletIndex) => (
            <Card
              size="small"
              key={`pallet-${palletIndex}`}
              title={
                <Space>
                  <Button
                    type="text"
                    size="small"
                    icon={pallet.isExpanded ? <DownOutlined /> : <RightOutlined />}
                    onClick={() => togglePalletExpansion(palletIndex)}
                  />
                  <Typography.Text strong style={{ width: 150, display: 'inline-block', verticalAlign: 'middle', lineHeight: '24px' }}>
                    {pallet.palletNumber}
                  </Typography.Text>
                </Space>
              }
              extra={<Popconfirm title="¿Eliminar esta tarima?" onConfirm={() => removePallet(palletIndex)} okText="Sí" cancelText="No" placement="left" disabled={!canEditContent}> <Button size="small" danger icon={<DeleteOutlined />} disabled={!canEditContent}>Eliminar Tarima</Button> </Popconfirm>}
              style={{
                marginBottom: 12,
                body: {
                  padding: pallet.isExpanded ? '8px 12px' : '0px',
                  display: pallet.isExpanded ? 'block' : 'none'
                }
              }}
            >
              {pallet.isExpanded && (
                <>
                  <Row gutter={8}>
                    <Col xs={24} sm={12}>
                      <Form.Item label="Dims Tarima" size="small" style={{ marginBottom: 8 }}>
                        <Space.Compact style={{ width: '100%' }}>
                          {loadingCatalogDefinitions ? (<Spin size="small" />) : errorCatalogDefinitions ? (<Text type="danger">{errorCatalogDefinitions}</Text>) : (
                            <Select
                              size="small"
                              value={pallet.dimensions || undefined}
                              placeholder="Seleccionar medida"
                              style={{ width: '100%' }}
                              onChange={(value) => handleDimensionChange(value, palletIndex)}
                              allowClear
                              disabled={!canEditContent}
                            >
                              <Option key="manual" value="manual" style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                Asignar manualmente...
                              </Option>
                              {catalogPalletDefinitions.map(def => (
                                <Option key={def._id} value={def.dimensions}>{def.dimensions}</Option>
                              ))}
                            </Select>
                          )}
                          {pallet.dimensions && !catalogPalletDefinitions.some(def => def.dimensions === pallet.dimensions) && (
                            <Tooltip title="Editar dimensiones manuales">
                              <Button
                                icon={<EditOutlined />}
                                onClick={() => handleEditManualDimensions(palletIndex)}
                                disabled={!canEditContent}
                              />
                            </Tooltip>
                          )}
                        </Space.Compact>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}><Form.Item label="Peso Tarima(KG)" size="small" style={{ marginBottom: 8 }}><InputNumber size="small" min={0} value={pallet.weight} onChange={(value) => updatePalletDetails(palletIndex, 'weight', value)} style={{ width: '100%' }} disabled={!canEditContent} /></Form.Item></Col>
                  </Row>

                  <Divider orientation="left" plain style={{ marginTop: 8, marginBottom: 8 }}>Artículos en Tarima</Divider>

                  {palletIndex === 0 && showServicesLabel && (
                    <Typography.Text strong style={{ display: 'block', marginBottom: '8px', color: '#52c41a' }}>
                      Servicios Incluidos:
                    </Typography.Text>
                  )}

                  <Table
                    dataSource={pallet.items}
                    rowKey="clientSideId"
                    pagination={false}
                    size="small"
                    bordered
                    columns={[
                      {
                        title: 'Código', dataIndex: 'lineNum', key: 'itemSelection', width: 150,
                        render: (lineNumValue, record, itemIdx) => {
                          const isServiceItem = record.itemCode && record.itemCode.toUpperCase().startsWith('SERV');
                          return (
                            <Select
                              size="small" showSearch value={lineNumValue} placeholder="Seleccionar" style={{ width: '100%' }}
                              onChange={(selectedSapLineNum) => updateItem(palletIndex, itemIdx, 'selectedLineNum', selectedSapLineNum)}
                              optionFilterProp="children" filterOption={(input, option) => (option?.children?.toString() ?? '').toLowerCase().includes(input.toLowerCase())}
                              allowClear disabled={isServiceItem || !canEditContent}
                            >
                              {deliveryData?.DocumentLines?.filter(line => {
                                const originalQtyForThisSAPLine = line.Quantity || 0;
                                if (originalQtyForThisSAPLine <= 0) { return false; }
                                let packedQtyForThisSAPLine = 0;
                                for (const p of pallets) {
                                  for (const i of p.items) {
                                    if (i.lineNum === line.LineNum) { packedQtyForThisSAPLine += (i.quantity || 0); }
                                  }
                                }
                                return (packedQtyForThisSAPLine < originalQtyForThisSAPLine) || (line.LineNum === record.lineNum);
                              }).map(line => (<Option key={line.LineNum} value={line.LineNum}>{line.ItemCode}</Option>))}
                            </Select>
                          );
                        },
                      },
                      {
                        title: 'Descripción', dataIndex: 'description', key: 'description',
                        render: (text, record) => {
                          let pedidoQuantity = 'N/A';
                          if (deliveryData && deliveryData.DocumentLines && record.lineNum !== null) {
                            const originalDocLine = deliveryData.DocumentLines.find(line => line.LineNum === record.lineNum && line.ItemCode === record.itemCode);
                            if (originalDocLine) { pedidoQuantity = originalDocLine.Quantity !== undefined ? originalDocLine.Quantity : 'N/A'; }
                          }
                          return (<Tooltip title={`Cantidad Pedido: ${pedidoQuantity}`}> <Input size="small" value={text} readOnly disabled style={{ border: 'none', background: 'transparent', cursor: 'default' }} /> </Tooltip>);
                        }
                      },
                      {
                        title: 'Cant', dataIndex: 'quantity', key: 'quantity', width: 70,
                        render: (text, record, itemIdx) => {
                          const isServiceItem = record.itemCode && record.itemCode.toUpperCase().startsWith('SERV');
                          return (<InputNumber size="small" min={1} value={text} onChange={(value) => updateItem(palletIndex, itemIdx, 'quantity', value)} style={{ width: '100%' }} disabled={record.lineNum === null || isServiceItem || !canEditContent} />);
                        },
                      },
                      { title: 'Dims', dataIndex: 'dimensions', key: 'dimensions', width: 100, render: (text) => (<Input size="small" value={text} readOnly disabled />) },
                      { title: 'Peso(KG)', dataIndex: 'weight', key: 'weight', width: 80, render: (text) => (<InputNumber size="small" value={text} readOnly disabled style={{ width: '100%' }} />) },
                      {
                        title: '% Empacado', key: 'packProgress', width: 100, align: 'center',
                        render: (_, record) => {
                          const itemCodeInPallet = record.itemCode;
                          const lineNumFromPalletItem = record.lineNum;
                          if (!itemCodeInPallet || lineNumFromPalletItem === null || !deliveryData?.DocumentLines) { return <Tag>N/A</Tag>; }
                          const originalDocumentLine = deliveryData.DocumentLines.find(docLine => docLine.ItemCode === itemCodeInPallet && docLine.LineNum === lineNumFromPalletItem);
                          if (!originalDocumentLine) { return <Tag color="orange">Error Línea</Tag>; }
                          const originalQuantityForThisDocLine = originalDocumentLine.Quantity || 0;
                          if (originalQuantityForThisDocLine <= 0) { return <Tag>N/A (Ped:0)</Tag>; }
                          let totalPackedForThisOriginalDocLine = 0;
                          pallets.forEach(p => { p.items.forEach(itemOnPallet => { if (itemOnPallet.itemCode === itemCodeInPallet && itemOnPallet.lineNum === lineNumFromPalletItem) { totalPackedForThisOriginalDocLine += (itemOnPallet.quantity || 0); } }); });
                          const percentage = Math.min(100, Math.floor((totalPackedForThisOriginalDocLine / originalQuantityForThisDocLine) * 100));
                          const isComplete = totalPackedForThisOriginalDocLine >= originalQuantityForThisDocLine;
                          return (<Progress percent={percentage} size="small" status={isComplete ? 'success' : (percentage > 0 ? 'active' : 'normal')} />);
                        }
                      },
                      {
                        title: 'Acción', key: 'action', width: 50, align: 'center',
                        render: (_, record, itemIdx) => {
                          const isServiceItem = record.itemCode && record.itemCode.toUpperCase().startsWith('SERV');
                          return (<Tooltip title={isServiceItem ? "Artículo de servicio no eliminable" : "Eliminar Artículo"}> <Button danger icon={<DeleteOutlined />} onClick={() => !isServiceItem && removeItemFromPallet(palletIndex, itemIdx)} size="small" type="text" disabled={isServiceItem || !canEditContent} /> </Tooltip>);
                        },
                      },
                    ]}
                    footer={() => (<Button size="small" type="dashed" onClick={() => addItemToPallet(palletIndex)} block icon={<PlusOutlined />} disabled={!canEditContent}> Agregar Artículo a Tarima </Button>)}
                  />
                </>
              )}
            </Card>
          ))}
          <Button size="middle" type="dashed" onClick={addNewPallet} block icon={<PlusOutlined />} style={{ marginTop: 12, height: '40px' }} disabled={!canEditContent}> Agregar Nueva Tarima </Button>
        </>
      )
    },
    ...(isEvidenceTabVisible ? [{
      key: 'evidence',
      label: `Evidencias (${evidenceImages.length})`,
      children: (
        <>
          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}> <Col> <Button icon={<CameraOutlined />} onClick={() => setPhotoQrVisible(true)} type="primary" disabled={!canManageEvidence}> Capturar Fotos con Móvil (QR) </Button> </Col> <Col> <Text type="secondary">Las fotos se guardan automáticamente al cerrar la sesión de captura móvil.</Text> </Col> </Row> <List grid={{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4, xl: 5, xxl: 6 }} dataSource={evidenceImages} locale={{ emptyText: "No hay imágenes de evidencia. Use el botón de captura." }}
            renderItem={(image, index) => {
              const isSavedInSap = !!image.sapAttachmentAbsoluteEntry;
              let canDeleteThisEvidence;
              let canEditDescription;
              if (isSavedInSap) {
                canEditDescription = !isReadOnly && permissions.canDeleteEvidence;
                canDeleteThisEvidence = !isReadOnly && permissions.canDeleteEvidence;
              } else {
                canEditDescription = !isReadOnly && canManageEvidence;
                canDeleteThisEvidence = !isReadOnly && canManageEvidence;
              }
              return (
                <List.Item>
                  <Card
                    hoverable size="small"
                    cover={<Image alt={image.description || `Evidencia ${index + 1}`} src={image.imageData} style={{ height: 180, objectFit: 'cover' }} preview={{ mask: <EyeOutlined /> }} onError={(e) => { e.target.src = "https://via.placeholder.com/200x180?text=Error+Img"; console.error("Error loading image", image.imageId); }} />}
                    actions={[
                      <Popconfirm title="¿Eliminar esta imagen de evidencia?" onConfirm={() => { setEvidenceImages(prev => prev.filter(img => img.imageId !== image.imageId)); message.info("Imagen marcada para eliminar. Guarde el listado para confirmar."); }} okText="Sí" cancelText="No" disabled={!canDeleteThisEvidence} >
                        <DeleteOutlined key="delete" style={{ color: canDeleteThisEvidence ? 'red' : 'rgba(0, 0, 0, 0.25)' }} />
                      </Popconfirm>,
                      isSavedInSap ? <Tooltip title={`Subido a SAP (Anexo: ${image.sapAttachmentAbsoluteEntry})`}><CheckOutlined style={{ color: 'green' }} /></Tooltip> : <Tooltip title="Pendiente de subir a SAP"><CloudUploadOutlined /></Tooltip>
                    ]}
                  >
                    <Card.Meta
                      title={<Input size="small" placeholder="Descripción de la foto" value={image.description} onChange={(e) => { const newDesc = e.target.value; setEvidenceImages(prev => prev.map(img => img.imageId === image.imageId ? { ...img, description: newDesc } : img)); }} disabled={!canEditDescription} />}
                      description={<Text type="secondary" style={{ fontSize: '11px' }}>ID: {image.imageId || 'N/A'}<br />Tomada: {image.timestamp ? moment(image.timestamp).format('DD/MM/YY HH:mm') : 'N/A'}</Text>}
                    />
                  </Card>
                </List.Item>
              );
            }}
          />
        </>
      )
    }] : []),
    {
      key: 'serials',
      label: 'Artículos con Serie',
      children: (
        <>
          <Typography.Text type="secondary" style={{ display: 'block', marginBottom: '12px' }}>
            Esta pestaña muestra los números de serie registrados en SAP para los artículos de esta entrega. No es editable aquí, solo para consulta.
          </Typography.Text>
          <Table dataSource={serialsDataSource} rowKey="key" size="small" bordered pagination={{ pageSize: 10 }} columns={[{ title: 'Línea SAP', dataIndex: 'lineNum', key: 'lineNum', width: 80, sorter: (a, b) => a.lineNum - b.lineNum }, { title: 'Código Artículo', dataIndex: 'itemCode', key: 'itemCode', width: 150, sorter: (a, b) => a.itemCode.localeCompare(b.itemCode) }, { title: 'Descripción Artículo', dataIndex: 'description', key: 'description' }, { title: 'Número de Serie', dataIndex: 'serialNumber', key: 'serialNumber', width: 200, sorter: (a, b) => a.serialNumber.localeCompare(b.serialNumber) },]} locale={{ emptyText: "No se encontraron números de serie en esta entrega." }} />
        </>
      )
    }
  ];

  return (
    <div style={{ padding: '12px' }}>
      {showSuccessModal && <SuccessAnimation folio={savedFolio} onClose={() => setShowSuccessModal(false)} />}
      {showErrorModal && <ErrorAnimation percent={incompletePercent} onClose={() => setShowErrorModal(false)} />}

      {/* --- INICIO: MODAL PARA DIMENSIONES MANUALES --- */}
      <Modal
        title="Asignar Dimensiones Manualmente"
        open={isManualDimModalVisible}
        onCancel={() => setIsManualDimModalVisible(false)}
        onOk={() => manualDimForm.submit()}
        okText="Guardar Dimensiones"
        cancelText="Cancelar"
        destroyOnClose
      >
        <Form
          form={manualDimForm}
          layout="vertical"
          onFinish={handleManualSave}
          initialValues={{ type: 'TARIMA' }}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item name="length" label="Largo (cm)" rules={[{ required: true, message: 'Requerido' }]}>
                <InputNumber min={0} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="width" label="Ancho (cm)" rules={[{ required: true, message: 'Requerido' }]}>
                <InputNumber min={0} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="height" label="Alto (cm)" rules={[{ required: true, message: 'Requerido' }]}>
                <InputNumber min={0} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item name="type" label="Tipo" rules={[{ required: true, message: 'Seleccione un tipo' }]}>
            <Select>
              <Option value="TARIMA">TARIMA</Option>
              <Option value="CAJA">CAJA</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
      {/* --- FIN: MODAL --- */}


      {isReadOnly && (<Alert message="MODO SOLO CONSULTA" description="Está visualizando este listado de empaque. No se permiten modificaciones." type="warning" showIcon style={{ marginBottom: 16 }} />)}
      {deliveryData?.packingList?.deletionStatus === 'eliminado' && (<Alert message="LISTADO ELIMINADO" description="Este listado de empaque se encuentra en la papelera y no puede ser modificado." type="error" showIcon style={{ marginBottom: 16 }} />)}
      {pdfErrorAlert && (<Alert message="Atención" description={pdfErrorAlert} type="warning" showIcon closable onClose={() => setPdfErrorAlert(null)} style={{ marginBottom: 16 }} />)}
      {saveErrorAlert && (<Alert message="Error de Validación" description={saveErrorAlert} type="error" showIcon closable onClose={() => setSaveErrorAlert(null)} style={{ marginBottom: 16 }} />)}

      {deliveryData && (<PhotoCaptureQR visible={photoQrVisible} docEntry={docEntry} formatoListado="A" onClose={() => setPhotoQrVisible(false)} onComplete={handlePhotoCaptureComplete} />)}
      <Modal title={<div><CloudUploadOutlined /> Cargando Imágenes a SAP</div>} open={uploadProgressVisible} footer={null} closable={false} centered maskClosable={false} width={400}> <div style={{ textAlign: 'center', padding: '20px 0' }}> <Progress type="circle" percent={totalUploadProgress} status="active" size={120} /> <div style={{ marginTop: 20 }}> <Text strong>{uploadStatus}</Text> <div style={{ marginTop: 15 }}> <Progress percent={currentImageProgress} status="active" strokeColor={{ '0%': '#108ee9', '100%': '#87d068' }} /> <Text type="secondary"> Imagen actual: {currentImageIndex + 1} de {totalImagesToUpload} </Text> </div> </div> </div> </Modal>

      {deliveryData && (
        <Row gutter={16} justify="space-between" align="middle" style={{ marginBottom: 12 }}>
          <Col> <Space> <Button size="small" icon={<ArrowLeftOutlined />} onClick={handleBack}>Volver</Button> <Title level={5} style={{ margin: 0 }}> Entrega {deliveryData.DocNum} {deliveryData.packingList?.packingListNumber && (<Tag color="blue" style={{ marginLeft: 8 }}> Folio: {deliveryData.packingList.packingListNumber} </Tag>)} </Title> </Space> </Col>
          <Col>
            <Space align="end">
              <Affix offsetTop={68}>
                <div>
                  <Card size="small" style={{ body: { padding: '4px 8px' } }}>
                    <Space>
                      <PercentageOutlined />
                      <Text strong>Progreso Total:</Text>
                      <Progress percent={overallProgress} size="small" style={{ width: 100 }} />
                    </Space>
                  </Card>
                </div>
              </Affix>
              <Button icon={<CameraOutlined />} onClick={() => setPhotoQrVisible(true)} style={{ height: '32px', position: 'relative', bottom: '10px' }} title={"Capturar evidencias fotográficas"} disabled={!canManageEvidence}> Evidencias </Button>
              <Button type="primary" icon={<SaveOutlined />} onClick={savePackingList} loading={saving} style={{ height: '32px', position: 'relative', bottom: '10px' }} disabled={isReadOnly || !permissions.canSaveOrEdit}> Guardar </Button>

              <Button type="default" icon={<PrinterOutlined />} onClick={generatePDF} loading={printLoading}
                style={{ height: '32px', position: 'relative', bottom: '10px' }}
                disabled={
                  isReadOnly ||
                  !permissions.canGeneratePdf ||
                  !deliveryData.packingList?._id ||
                  deliveryData.packingList?.status === 'draft' ||
                  deliveryData.packingList?.deletionStatus !== 'activo'
                }
                title={
                  !deliveryData.packingList?._id || deliveryData.packingList?.status === 'draft'
                    ? "Guarde y complete el listado primero"
                    : "Generar PDF"
                }
              >Generar PDF
              </Button>


              <Button
                type="default"
                icon={<TagsOutlined />}
                onClick={handleGenerateLabels}
                loading={labelsLoading}
                style={{ height: '32px', position: 'relative', bottom: '10px' }}
                disabled={
                  isReadOnly ||
                  !permissions.canGeneratePdf ||
                  !deliveryData.packingList?._id ||
                  deliveryData.packingList?.status === 'draft' ||
                  deliveryData.packingList?.deletionStatus !== 'activo'
                }
                title={
                  !deliveryData.packingList?._id || deliveryData.packingList?.status === 'draft'
                    ? "Guarde y complete el listado primero"
                    : "Generar Etiquetas"
                }
              >
                Generar Etiquetas
              </Button>

            </Space>
          </Col>
        </Row>

      )}

      {deliveryData && (
        <Card style={{ marginBottom: 12, body: { padding: '12px 16px' } }}>
          <Row gutter={8}> <Col xs={24} sm={12} md={8}> <Text strong>Cliente:</Text> <Text> {deliveryData.CardName} ({deliveryData.CardCode})</Text> </Col> <Col xs={24} sm={12} md={8}> <Text strong>Dirección Envío:</Text> <Text> {deliveryData.Address || deliveryData.ShipToCode || 'N/A'}</Text> </Col> <Col xs={24} sm={12} md={8}> <Text strong>Fecha Entrega:</Text> <Text> {moment(deliveryData.DocDate).utc().format('DD/MM/YYYY')}</Text> </Col> </Row>
          <Divider style={{ marginTop: 12, marginBottom: 12 }} />

          <Row gutter={8} style={{ marginBottom: 12 }}>
            <Col>
              <Text strong>Comentarios Generales de Entrega:</Text> <Text>{deliveryData.Comments || ''}</Text>
            </Col>
          </Row>

          <Form
            key={deliveryData.DocNum}
            form={form}
            layout="inline"
            size="small"
            initialValues={{
              comments: (deliveryData?.packingList?.formato !== 'B' && deliveryData?.packingList?.comments) || ''
            }}
          >

            <Form.Item name="comments" label="Comentarios" style={{ flexGrow: 1 }}>
              <Input.TextArea
                rows={1}
                placeholder="Comentarios adicionales..."
                disabled={!canEditContent}
              />
            </Form.Item>

          </Form>
          <Text strong style={{ color: '#b1b1b1' }}> Aviso: Solo los primeros 45 caracteres del comentario se imprimirán en la etiqueta.</Text>

        </Card>
      )}
      {deliveryData && (
        <Tabs
          defaultActiveKey="pallets"
          size="small"
          style={{ marginTop: 0 }}
          items={tabItems}
        />
      )}
    </div>
  );
};

export default PackingListEditor;